import { css } from "@/utils/css";

type Item = {
	id: string;
	label: string | React.ReactNode;
	[key: string]: any;
};

type Props = React.PropsWithChildren & {
	items: Array<Item>;
	selectedItem?: Item;
	onSelectItem?: (item: Item) => void;
	className?: string;
};

export default function Sidebar({ items, selectedItem, onSelectItem, className = "", children }: Props) {
	return (
		<div className={css("atml-sidebar-container", className)}>
			<div className={css("atml-sidebar")}>
				<ul>
					{items.map((item) => {
						const { id, label } = item;
						const isSelected = selectedItem?.id === id;

						return (
							<li key={id}>
								<a>
									<button type="button" className={css(`atml-sidebar-item ${isSelected ? "active" : ""}`)} onClick={() => onSelectItem?.(item)}>
										{label}
									</button>
								</a>
							</li>
						);
					})}
				</ul>
			</div>
			<div className={css("atml-content-area")}>{children}</div>
		</div>
	);
}
